const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer.php';
const TWITTER_SHARE_URL = 'https://twitter.com/share';

export const facebookShareUrl = ({ url }) => `${FACEBOOK_SHARE_URL}?u=${url}`;
export const twitterShareUrl = ({ url, text }) =>
  `${TWITTER_SHARE_URL}?text=${text}&url=${url}`;
